export default "__VITE_ASSET__DmIMtFNW__"